<script>
import {
    Line
} from "vue-chartjs";
//import _ from "lodash";
import adminServ from "@/http/requests/admin/index.js";
export default {
    extends: Line,
    data() {
        return {
            date: new Date().getFullYear(),
            data: {
                labels: [],
                datasets: [{
                    data: new Array(31),
                    label: "Nombre De Commande ",
                    borderColor: "#28C76F",
                    fill: false
                }]
            },
            options: {

            },
            localData: []
        };
    },
    methods: {
        getdata() {
            var d = new Date();

            let localDataN = this.localData
            var dateOffset = (24 * 60 * 60 * 1000)
            let day = d.getDate();
            let month = d.getMonth()
            let i = 0;
            for (i = 0; i <= 31; i++) {
                this.data.datasets[0].data[i] = 0
                day = d.getDate()
                day = day + '';
                if (day.length == 1)
                    day = '0' + day
                month = d.getMonth()
                month = month + '';

                if (month.length == 1) {

                    month = '0' + month

                }
                this.data.labels.push(month + '-' + day)
                d.setTime(d.getTime() + dateOffset)
            }

            for (i = 0; i < localDataN.length; i++) {

                this.data.datasets[0].data[this.data.labels.indexOf(localDataN[i][1].substring(5, 10))] = localDataN[i][0]

            }

            this.renderChart(this.data, this.options);
            this.show = true;
        },

    },
    mounted() {
        this.renderChart(this.data, this.options);
    },
    created() {

        if (this.$store.state.AppActiveUser.id != '') {
            adminServ.getNbreCommandePoratilMois().then(response => {

                this.localData = response.data;
                this.getdata();
            });

        } else

            this.$store.subscribe(mutation => {
                if (mutation.type === "UPDATE_USER_INFO") {
                    adminServ.getNbreCommandePoratilMois().then(response => {
                        this.localData = response.data;

                        this.getdata();
                    });

                }
            });
    }
};
</script>
